import { render, staticRenderFns } from "./regular.vue?vue&type=template&id=2a5a8788&scoped=true&"
import script from "./regular.vue?vue&type=script&lang=js&"
export * from "./regular.vue?vue&type=script&lang=js&"
import style0 from "./regular.vue?vue&type=style&index=0&id=2a5a8788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a8788",
  null
  
)

export default component.exports